<template>
    <div class="switch-wrapper">
        <input id="toggle" v-model="checked" type="checkbox" class="checkbox">  
        <label for="toggle" class="switch" />
    </div>
</template>

<script>
export default {
    props: {
        checkedStartValue: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            checked: this.checkedStartValue
        };
    },
    watch: {
        checked() {
            this.$emit('updateValue', this.checked);
        }
    }
};
</script>

<style lang="scss" scoped>
    .switch-wrapper {
        height: 20px;
    }
    .switch {
        cursor: pointer;
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
        background-color: $lightgray;
        border-radius: 20px;
        transition: all 0.3s;
    }
    .switch::after {
        content: '';
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius:50%;
        background-color: $white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }

    .checkbox:checked + .switch::after {
        left : 20px;
    }
    .checkbox:checked + .switch {
        background-color: $pink;
    }
    .checkbox {
        display : none;
    }
</style>